export default "__VITE_ASSET__fCVkjsMM__"